<script>
import getError from './errors';

export default {
  props: {
    value: [Number, String],
    validationRules: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    this.$el.addEventListener('focus', this.reset, false);
    this.$el.addEventListener('input', this.validation, false);
    this.$el.addEventListener('blur', this.validation, false);
  },
  beforeDestroy() {
    this.$el.removeEventListener('focus', this.reset, false);
    this.$el.removeEventListener('input', this.validation, false);
    this.$el.removeEventListener('blur', this.validation, false);
  },
  data() {
    return {
      error: null,
    };
  },
  computed: {
    required() {
      return !!this.validationRules.required;
    },
    email() {
      return !!this.validationRules.email;
    },
    phone() {
      return !!this.validationRules.phone;
    },
    min() {
      return this.validationRules.min || null;
    },
    max() {
      return this.validationRules.max || null;
    },
    date() {
      const { date } = this.validationRules;
      return this.$validate.isObjectWithFields(date, ['min', 'max']) ? date : null;
    },
    passport() {
      const { passport } = this.validationRules;
      return this.$validate.isObjectWithFields(passport, ['validation']) ? passport : null;
    },
  },
  methods: {
    reset() {
      this.error = null;
    },
    validation() {
      this.error = getError(this.value, {
        required: this.required,
        email: this.email,
        phone: this.phone,
        min: this.min,
        max: this.max,
        date: this.date,
        passport: this.passport,
      });
    },
  },
  render() {
    return this.$scopedSlots.default({
      error: this.error,
    });
  },
};
</script>

